import styled from 'styled-components';
import PropTypes from 'prop-types';

const Card = styled.div`
    border-radius: ${({ borderRadius }) => (borderRadius || '8px')};
    padding: ${({ padding }) => (padding || '20px')};
    box-shadow: ${({ noShadow }) => (noShadow ? 'none' : '0 2px 2px #9C9C9C24')};
    background-image: ${({ bgImg }) => `url('${bgImg}')`};
    background-position: ${({ bgPosition }) => (bgPosition || 'center')};
    background-size: ${({ bgSize }) => (bgSize || 'cover')};
    background-color: ${({ bgColor }) => (bgColor || '#FFFFFF')};   
    position: ${({ position }) => (position || 'relative')};
    border: ${({ border }) => (border || 'none')};
    height: ${({ height }) => (height || 'auto')};
    cursor: ${({ cursor }) => (cursor || 'auto')};
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin};
    transition: .3s;
    overflow: ${({ overflow }) => (overflow ? 'hidden' : 'unset')};
    ${({ hoverable }) => hoverable && `
        &:hover {
            box-shadow: 0px 6px 8px #0000007D;
            transition: .3s;
        }
    `}
    &.selected {
        box-shadow: 0px 6px 8px #0000007D;
        transition: .3s;
    }
`;

PropTypes.Card = {
    padding: PropTypes.string,
    borderRadius: PropTypes.string,
    noShadow: PropTypes.bool,
    bgImg: PropTypes.string,
    bgPosition: PropTypes.string,
    bgSize: PropTypes.string,
    bgColor: PropTypes.string,
    position: PropTypes.string,
    border: PropTypes.string,
    height: PropTypes.string,
    cursor: PropTypes.string,
    hoverable: PropTypes.bool,
    overflow: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Card;
